import React from 'react';

const FoodTypeBadge = ({ foodType, size = 'small' }) => {
  const getBadgeConfig = (type) => {
    switch (type) {
      case 'veg':
        return {
          icon: '🟢',
          text: 'VEG',
          bgColor: '#dcfce7',
          textColor: '#166534',
          borderColor: '#22c55e'
        };
      case 'non-veg':
        return {
          icon: '🔴',
          text: 'NON-VEG',
          bgColor: '#fee2e2',
          textColor: '#dc2626',
          borderColor: '#ef4444'
        };
      case 'egg':
        return {
          icon: '🟡',
          text: 'EGG',
          bgColor: '#fef3c7',
          textColor: '#d97706',
          borderColor: '#f59e0b'
        };
      default:
        return {
          icon: '🟢',
          text: 'VEG',
          bgColor: '#dcfce7',
          textColor: '#166534',
          borderColor: '#22c55e'
        };
    }
  };

  const config = getBadgeConfig(foodType);
  const isLarge = size === 'large';

  return (
    <div
      style={{
        display: 'inline-flex',
        alignItems: 'center',
        gap: isLarge ? '8px' : '4px',
        padding: isLarge ? '8px 12px' : '4px 8px',
        backgroundColor: config.bgColor,
        color: config.textColor,
        border: `1px solid ${config.borderColor}`,
        borderRadius: isLarge ? '12px' : '8px',
        fontSize: isLarge ? '14px' : '12px',
        fontWeight: '600',
        textTransform: 'uppercase',
        letterSpacing: '0.5px',
        boxShadow: '0 1px 3px rgba(0, 0, 0, 0.1)',
        transition: 'all 0.2s ease'
      }}
      onMouseOver={(e) => {
        e.currentTarget.style.transform = 'scale(1.05)';
        e.currentTarget.style.boxShadow = '0 2px 8px rgba(0, 0, 0, 0.15)';
      }}
      onMouseOut={(e) => {
        e.currentTarget.style.transform = 'scale(1)';
        e.currentTarget.style.boxShadow = '0 1px 3px rgba(0, 0, 0, 0.1)';
      }}
    >
      <span style={{ fontSize: isLarge ? '16px' : '12px' }}>
        {config.icon}
      </span>
      <span>{config.text}</span>
    </div>
  );
};

export default FoodTypeBadge;





